export default __webpack_public_path__ + "static/media/plus-blue.bfada47f.svg";